import { defineMessages } from 'react-intl';

export default defineMessages({
    successMessage: {
        id: 'endorsement.common.views.change-bound.successMessage',
        defaultMessage: 'Your Change was Bound Successfully.',
    },
    billingMessage: {
        id: 'endorsement.common.views.change-bound.billingMessage',
        defaultMessage: 'You can check the payment schedule and invoices here: ',
    },
    renewalInfoMessage: {
        id: 'endorsement.common.views.change-bound.renewalInfoMessage',
        defaultMessage: 'Changes have been applied to the renewal transaction. To retain these changes you must quote the renewal transaction using this link: ',
    },
    renewalInfoMessage_TFPA: {
        id: 'endorsement.common.views.change-bound.renewalInfoMessage_TFPA',
        defaultMessage: 'This change has been applied to the renewal transaction: ',
    },
    renewalScheduledMessage: {
        id: 'endorsement.common.views.change-bound.renewalScheduledMessage',
        defaultMessage: 'This policy has a renewal scheduled to take effect in the future. To apply this change to the future renewal term you must complete a separate policy change.',
    }
});
